<div class="col-md-12 mb-30">
  <div class="card card-statistics mb-30">
    <div class="card-body">
      <div #factorPdfContent id="letterRequestCustomerFactor2Pdf" dir="rtl" style="background: #fff;">
        <h5 class="card-title">جزئیات فاکتور رسید شماره '{{ receipt?.code || calibrationId }}'</h5>
        <div class="row">
          <div class="form-group col-md-3"><label>شماره رسید</label><input type="text" class="form-control"
              [value]="receipt?.code || calibrationId" readonly /></div>
          <div class="form-group col-md-3"><label>نام مشتری</label><input type="text" class="form-control"
              [value]="receipt?.customerName || '-'" readonly /></div>
          <div class="form-group col-md-3"><label>تاریخ ثبت</label><input type="text" class="form-control"
              [value]="receipt?.subDatePersian || '-'" readonly /></div>
          <div class="form-group col-md-3"><label>تاریخ تایید نهایی</label><input type="text" class="form-control"
              [value]="receipt?.financeConfirmDatePersian || receipt?.financeConfirmDate || '-'" readonly /></div>
        </div>

        <img *ngIf="loading" src="assets/Loading.gif" style="width: 25px;" />

        <div *ngIf="!loading">
          <div class="device-list">
            <article class="device-card" *ngFor="let item of factorRows; let i = index">
              <header class="device-card-header">
                <div class="device-identity" [title]="item.deviceTitle || ''">
                  <span class="device-index">{{ i + 1 }}</span>
                  <span class="device-name">{{ item.deviceName || '-' }}</span>
                </div>
                <div class="device-meta">
                  <span><small>نام انگلیسی</small><strong>{{ item.deviceTitle || '-' }}</strong></span>
                  <span><small>محل کالیبراسیون</small><strong>{{ item.locationName || '-' }}</strong></span>
                  <span><small>تعداد</small><strong>{{ item.count | number }}</strong></span>
                </div>
              </header>

              <section class="device-section">
                <h6 class="section-title"><i class="fa fa-money"></i> اطلاعات مالی</h6>
                <div class="section-grid">
                  <div class="info-item"><span>مبلغ واحد (ریال)</span>
                    <strong class="numeric-value">{{ getUnitPrice(item) | number }}</strong></div>
                  <div class="info-item"><span>افزایش مدیر (درصد)</span>
                    <strong class="numeric-value">{{ item.incPercentModir | number }}</strong></div>
                  <div class="info-item"><span>افزایش مدیر (ریال)</span>
                    <strong class="numeric-value">{{ item.incRailModir | number }}</strong></div>
                  <div class="info-item"><span>تعرفه اضافه تجهیز (درصد)</span>
                    <strong class="numeric-value">{{ item.incRailPercent | number }}</strong></div>
                  <div class="info-item"><span>تعرفه اضافه تجهیز (ریال)</span>
                    <strong class="numeric-value">{{ item.incRail | number }}</strong></div>
                  <div class="final-total"><span>جمع کل واحد (ریال)</span>
                    <strong>{{ getInvoiceTotal(item) | number }}</strong></div>
                  <div class="final-total"><span>قیمت واحد نهایی (ریال)</span>
                    <strong>{{ getFinalUnitPrice(item) | number }}</strong></div>
                  <div class="final-total"><span>مبلغ ردیف با افزایش‌ها (ریال)</span>
                    <strong>{{ getFinalTotal(item) | number }}</strong></div>
                </div>
              </section>

              <section class="device-section result-section">
                <h6 class="section-title"><i class="fa fa-file-text-o"></i> توضیحات</h6>
                <div class="result-grid">
                  <div class="text-result"><span>توضیحات تجهیز</span><p>{{ item.priceDescription || '-' }}</p></div>
                  <div class="text-result"><span>توضیحات مشتری</span><p>{{ item.description || '-' }}</p></div>
                  <div class="text-result" *ngIf="item.confirmInvoiceDescription?.trim()">
                    <span>توضیحات تأیید کار و پیش‌فاکتور</span>
                    <p dir="rtl" style="white-space: pre-wrap; overflow-wrap: anywhere; text-align: right;">{{ item.confirmInvoiceDescription }}</p>
                  </div>
                </div>
              </section>
            </article>
            <div class="empty-detail" *ngIf="factorRows.length === 0">تجهیزی برای این رسید ثبت نشده است.</div>
          </div>

          <div class="totals-footer factor-summary">
            <div><span>جمع مبلغ پایه دستگاه‌ها (ریال)</span><strong>{{ totals.baseDevicesTotal | number }}</strong></div>
            <div><span>جمع افزایش مدیر (ریال)</span><strong>{{ totals.managerIncreaseTotal | number }}</strong></div>
            <div><span>جمع تعرفه اضافه تجهیز (ریال)</span><strong>{{ totals.additionalIncreaseTotal | number }}</strong></div>
            <div><span>جمع کل دستگاه‌ها (ریال)</span><strong>{{ totals.devicesTotal | number }}</strong></div>
            <div><span>جمع دستگاه‌های محل مشتری (ریال)</span><strong>{{ totals.siteDevicesTotal | number }}</strong></div>
            <div><span>جمع دستگاه‌های آزمایشگاه (ریال)</span><strong>{{ totals.labDevicesTotal | number }}</strong></div>
            <div><span>هزینه خدمات (ریال)</span><strong>{{ totals.serviceCost | number }}</strong></div>
            <div><span>جمع قبل از تخفیف (ریال)</span><strong>{{ totals.subTotal | number }}</strong></div>
            <div><span>تخفیف ({{ totals.discountPercent | number }}٪) (ریال)</span><strong>{{ totals.discountAmount | number }}</strong></div>
            <div><span>مبلغ پس از تخفیف (ریال)</span><strong>{{ totals.afterDiscount | number }}</strong></div>
            <div><span>ارزش افزوده ({{ totals.vatPercent | number }}٪) (ریال)</span><strong>{{ totals.vatAmount | number }}</strong></div>
            <div><span>جمع کل نهایی (ریال)</span><strong>{{ totals.finalTotal | number }}</strong></div>
          </div>
        </div>
      </div>

      <br />
      <div *ngIf="!loading">
        <button type="button" class="btn btn-danger" style="margin-left: 10px;" [disabled]="pdfProcessing"
          (click)="exportPdf()"><i class="fa fa-file-pdf-o"></i>
          {{ pdfProcessing ? 'در حال ایجاد PDF...' : 'خروجی PDF' }}</button>
        <button type="button" class="btn btn-success" style="margin-left: 10px;" [disabled]="excelProcessing"
          (click)="exportExcel()"><i class="fa fa-file-excel-o"></i>
          {{ excelProcessing ? 'در حال ایجاد Excel...' : 'خروجی Excel' }}</button>
        <button *ngIf="!isFactorConfirmed" type="button" class="btn btn-success" style="margin-left: 10px;"
          [disabled]="factorConfirming" (click)="openFactorConfirmModal(factorConfirmTemplate)">
          <i class="fa fa-check"></i> فاکتور ثبت شد
        </button>
        <span *ngIf="isFactorConfirmed" class="badge badge-success" style="margin-left: 10px; padding: 10px;">
          فاکتور ثبت شده<span *ngIf="receipt?.factorConfirmDatePersian"> - {{ receipt?.factorConfirmDatePersian }}</span>
        </span>
        <img *ngIf="factorConfirming" src="assets/Loading.gif" style="width: 25px; margin-left: 10px;" />
        <button routerLink="/LetterrequestcustomerFactor" type="button" class="btn btn-warning"
          [disabled]="factorConfirming"><i
            class="fa fa-mail-reply"></i> بازگشت</button>
      </div>
    </div>
  </div>
</div>

<ng-template #factorConfirmTemplate>
  <div class="modal-header" dir="rtl">
    <h4 class="modal-title pull-left">ثبت نهایی فاکتور رسید شماره '{{ receipt?.code || calibrationId }}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="factorConfirmModalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" dir="rtl">آیا از ثبت نهایی فاکتور اطمینان دارید؟</div>
  <div class="modal-footer" dir="rtl">
    <button type="button" class="btn btn-warning" [disabled]="factorConfirming" (click)="confirmFactor()">
      بله، فاکتور ثبت شد <i class="fa fa-check"></i>
    </button>
    <button type="button" class="btn btn-danger" [disabled]="factorConfirming"
      (click)="factorConfirmModalRef.hide()">انصراف</button>
  </div>
</ng-template>
